




import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StreakNotificationType, StreakStats } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('globals', ['streakData']),
  },
})
export default class StreakButtonWrapper extends Vue {
  @Watch('streakData')
  private streakDataChanged(val: StreakStats | undefined, oldVal: StreakStats | undefined) {
    let notificationType: StreakNotificationType = 'none';
    if (val && oldVal) {
      if (val.current_streak_length > oldVal.current_streak_length) {
        notificationType = 'newstreak';
      }
      if (
        val.problems_attempted_total === 1 &&
        val.problems_attempted_today > oldVal.problems_attempted_today
      ) {
        notificationType = 'newuser';
      }
    }
    if (notificationType !== 'none') {
      this.$store.dispatch('streakPopup/showNotification', notificationType);
    }
  }
}
